import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "content_con" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "content_size" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = ["src"]
const _hoisted_9 = ["src"]
const _hoisted_10 = ["src"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]

import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
// import leftTemplate4 from "@/components/leftTemplate4.vue";



export default /*@__PURE__*/_defineComponent({
  __name: 'about',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[0] || (_cache[0] = _createStaticVNode("<div style=\"font-size:15px;width:1200px;line-height:25px;color:#000;margin:12px auto;font-weight:bold;\" data-v-284ca6b9><span data-v-284ca6b9>网站理念</span></div><div style=\"font-size:14px;width:1200px;line-height:25px;color:#000;margin:12px auto;\" data-v-284ca6b9> “标识山西·影像资源共享平台”秉承“共建、共创、共享、共融”的核心理念，致力于为海量山西影像创作人提供一个多元、智能、开放的优质创作内容新生态，为山西本土市场提供一站式数字影像解决方案，持续推动山西数字形象影像建设，树立对外宣传新窗口，打造讲好山西故事新阵地。 </div><div style=\"font-size:15px;width:1200px;line-height:25px;color:#000;margin:12px auto;font-weight:bold;\" data-v-284ca6b9><span data-v-284ca6b9>网站简介</span></div><div style=\"font-size:14px;width:1200px;line-height:25px;color:#000;margin:12px auto;\" data-v-284ca6b9> 网站拥有海量的山西影像素材，超高清的内容资源，以创新的合作模式汇集各类影像人才。平台以文化产业数字化服务为抓手，以优质内容原创生产为依托，充分调动主流媒体独有资源优势、创作及制作优势，进一步强化山西形象标识，树立山西对外宣传新窗口；平台以为山西影视行业服务为宗旨，为项目团队降本增效，为广大影像创作人提供优质素材、内容及健康的创作环境，进一步增强全省的影像人才建设；平台将通过影视资源配置、服务支撑和协同发展等功能，与全省影视制作单位携手同行，进一步助力山西数字影像建设、影视行业新场景、影像行业新生态的全面发展。 </div><div style=\"font-size:15px;width:1200px;line-height:25px;color:#000;margin:12px auto;font-weight:bold;\" data-v-284ca6b9><span data-v-284ca6b9>网站功能</span></div><div style=\"font-size:14px;width:1200px;line-height:25px;color:#000;margin:12px auto;\" data-v-284ca6b9> 平台将打破传统影像生产模式，创造多元的影像视觉制作新生态。集合各渠道资源，为用户提供影像业务、影视素材、影像活动、设备器材、影像学院等各类服务，并通过影视培训、人员招募等活动实现用户的个人成长及合作交流。用户一方面可以通过平台内的全场景成品制作模板，高效、智能提升影视制作效率。另一方面还可以进入网站首页，按需求搜索素材、案例，找到匹配业务的创造人、业务和器材，实现接单自由。 </div><div style=\"font-size:14px;width:1200px;line-height:25px;color:#000;margin:12px auto;\" data-v-284ca6b9> 平台以创作人招募、AIGC赋能、影视共创、微短剧IP和品牌跨界合作五大赛道为核心，持续推出线上创作人服务、线下影像联名活动、微短剧共创计划、影视合作战略服务等业务板块及项目内容，通过技术赋能，4K/8K超高清技术应用，和AI、VR等技术结合，为作品创作和内容传播提供更多新可能。 </div><div style=\"font-size:14px;width:1200px;line-height:25px;color:#000;margin:12px auto;\" data-v-284ca6b9> 让“好内容拥有好收益”，用影像创造长效价值。平台也将持续聚焦创作、变现、影像业务交易等核心板块，打通B2B、B2C全链路交易模式，联动各政府机构、企事业单位、大型项目，为影像创作者嫁接桥梁，为项目供给优质人才，助力创作者获得商单主动权，最终形成双赢、多赢的良性交易模式。 </div>", 8)),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00005.png'),
          style: {"margin":"12px auto","display":"block"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_4),
        _cache[1] || (_cache[1] = _createElementVNode("div", { style: {"font-size":"14px","width":"1200px","line-height":"25px","color":"#000","margin":"12px auto"} }, " 标识山西·影像资源共享平台是山西广播电视台旗下山西星卫视传媒有限公司创建首个山西影像行业共创价值的影视产业平台，以“共融共创 共享共建”为口号，立足于山西数字影像科技建设，聚焦山西优秀影视创作人，打造具有搜索、购买、支付一站式在线服务功能，汇集山西本土千万高清视频资源，以“资源共享、优质视觉创意、解决影视业务需求”为核心，逐步拓展出找业务、找器材、培训等多种板块的服务。 ", -1)),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00006.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_5),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00007.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_6),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00008.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_7),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00009.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_8),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00010.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_9),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00011.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_10),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00012.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_11),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00013.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_12),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00014.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_13),
        _createElementVNode("img", {
          src: require('@/assets/about/IMG_00015.png'),
          style: {"margin":"12px auto","display":"block","width":"1200px"},
          alt: "关于星卫视集团"
        }, null, 8, _hoisted_14)
      ])
    ])
  ]))
}
}

})